import React from 'react';
var WindowDispatchContext = React.createContext(null);
export var WindowDispatchProvider = WindowDispatchContext.Provider;
export var WindowDispatchConsumer = WindowDispatchContext.Consumer;
export default WindowDispatchContext;
//# sourceMappingURL=window-dispatch-context.js.map